import { Box, Card, H2, Separator } from '@betterment/samba-react';
import { CardLoader } from '@betterment/shared-components';
import { Fragment } from 'react/jsx-runtime';

import { CheckingOptionInManualReviewRow } from './CheckingOptionInManualReviewRow';
import { CheckingReceivedInvitationRow } from './CheckingReceivedInvitationRow';
import { GoalCreationIntentRow } from './GoalCreationIntentRow';

import { useProductOnboardingOptions } from '../hooks/useProductOnboardingOptions';

export const ProductOnboardingIntentsCard: React.FC = () => {
  const { data } = useProductOnboardingOptions();

  if (!data) return <CardLoader />;

  const { checkingOptionInManualReview, goalCreationIntents, checkingReceivedInvitations } = data.intents;
  if (!checkingOptionInManualReview && !goalCreationIntents.length && !checkingReceivedInvitations.length) return null;

  return (
    <Card data-testid="specPageProductIntentsCard">
      <Card.Header css={{ display: 'flex', justifyContent: 'space-between', padding: 'space.300' }}>
        <H2 variant="title200">Finish setting up</H2>
      </Card.Header>
      <Card.Content>
        {checkingOptionInManualReview && (
          <Fragment key={1}>
            <Separator css={{ fullWidthWithInset: 'space.300' }} />
            <CheckingOptionInManualReviewRow option={checkingOptionInManualReview} />
          </Fragment>
        )}
        {checkingReceivedInvitations.map(invitation => (
          <Fragment key={invitation.id}>
            <Separator css={{ fullWidthWithInset: 'space.300' }} />
            <CheckingReceivedInvitationRow invitation={invitation} />
          </Fragment>
        ))}
        {goalCreationIntents.map(intent => (
          <Box key={intent.id} data-testid="specPageIntentCard">
            <Separator css={{ fullWidthWithInset: 'space.300' }} />
            <GoalCreationIntentRow intent={intent} />
          </Box>
        ))}
      </Card.Content>
    </Card>
  );
};
